import SvgIcon from "./SvgIcon";
import IconButton from "./IconButton";

interface Props {
    className?: string;
    width?: string;
    height?: string;
    sizeInPixel?: number;
}

export default function SymbolGasMeterIcon({className = '', width = '', height = '', sizeInPixel}: Props) {
    if (sizeInPixel) {
        width = sizeInPixel + 'px';
        height = sizeInPixel + 'px';
    }
    return <>
        <SvgIcon
            defaultFill={'fill-amber-500'}
            className={className}
            width={width}
            height={height}>
            <path d="M320-80q-66 0-113-47t-47-113v-400q0-66 47-113t113-47h40v-80h80v80h80v-80h80v80h40q66 0 113 47t47 113v400q0 66-47 113T640-80H320Zm0-80h320q33 0 56.5-23.5T720-240v-400q0-33-23.5-56.5T640-720H320q-33 0-56.5 23.5T240-640v400q0 33 23.5 56.5T320-160Zm0-400h320v-80H320v80Zm160 320q42 0 71-28.5t29-69.5q0-33-19-56.5T480-490q-63 72-81.5 96T380-338q0 41 29 69.5t71 28.5ZM240-720v560-560Z"/>
        </SvgIcon>
    </>;
}

interface ButtonProps {
    className?: string;
    onClick?: () => void;
    title: string;
    svgClassName?: string;
}

export function SymbolGasMeterButton({className = '', onClick, title, svgClassName}: ButtonProps) {
    return <>
        <IconButton
            className={className}
            onClick={onClick}
            title={title}
        >
            <SymbolGasMeterIcon className={svgClassName}/>
        </IconButton>
    </>;
}